$('#recipeCarousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    prevArrow: `<button type="button" class="slick-prev btn btn-link carousel-control-prev w-auto shadow-none"><span class="carousel-control-prev-icon rounded-circle" aria-hidden="true"></span><span class="sr-only">Forrige</span></button>`,
    nextArrow: `<button type="button" class="slick-next btn btn-link carousel-control-next w-auto shadow-none"><span class="carousel-control-next-icon rounded-circle" aria-hidden="true"></span><span class="sr-only">Næste</span></button>`
});